/* RESPONSIBLE TEAM: team-standalone */

import type { ConversationExcerptData } from '../definitions';
import type FreshdeskLegacyPlatform from '../../freshdesk-legacy';

export default class FreshdeskLegacyConversationExcerpt implements ConversationExcerptData {
  private platform: FreshdeskLegacyPlatform;

  constructor(platform: FreshdeskLegacyPlatform) {
    this.platform = platform;
  }

  title(excerptsEnabled: boolean) {
    let defaultPrefix = 'fin-ai-agent.knowledge.content-sources.conversation-excerpts';
    let prefix = excerptsEnabled ? `${defaultPrefix}.enabled` : defaultPrefix;
    return this.platform.intl.t(`${prefix}.default`);
  }

  get link() {
    return undefined;
  }
}
